export const splitIntoBullets = (text: string) =>
  text
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
